module.exports = __webpack_public_path__ + "static/media/Menu.9fbfb722.svg";